import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Colours from '../definitions/Colours';


function ReviewStar({ percentWidth, ...otherProps }) {
    const viewBoxExtent = 24;
    const partialWidth = percentWidth * viewBoxExtent / 100;
    // each clipPath's id should be unique in DOM due to inconsistent browser support
    const uniqueId = 'partialStar' + Math.random().toString().slice(-6);
    
    return (
        <MyStar
            {...otherProps}
        >
            <MyNoStarImage
                viewBox="0 0 24 24"
            >
                <polygon
                    fill={Colours.STONE}
                    opacity="0.5"
                    points="12 19 4.94657697 22.7082039 6.2936609 14.854102 0.587321804 9.29179607 8.47328849 8.14589803 12 1 15.5267115 8.14589803 23.4126782 9.29179607 17.7063391 14.854102 19.053423 22.7082039"
                />
            </MyNoStarImage>
            
            <MyFullStarImage
                viewBox="0 0 24 24"
            >
                <defs>
                    <clipPath id={uniqueId}>
                        <rect
                            x="0"
                            y="0"
                            width={partialWidth}
                            height="24"
                        />
                    </clipPath>
                </defs>
        
                <polygon
                    fill={Colours.YUZU}
                    points="12 19 4.94657697 22.7082039 6.2936609 14.854102 0.587321804 9.29179607 8.47328849 8.14589803 12 1 15.5267115 8.14589803 23.4126782 9.29179607 17.7063391 14.854102 19.053423 22.7082039"
                    clipPath={'url(#' + uniqueId + ')'}
                />
            </MyFullStarImage>
        </MyStar>
    );
}

ReviewStar.propTypes = {
    percentWidth: PropTypes.number,
};

ReviewStar.defaultProps = {
    percentWidth: 100,
};

const MyStar = styled.span`
    display: inline-block;
    position: relative;
    font-size: 0;
    width: 100%;
`;
const MyNoStarImage = styled.svg``;

const MyFullStarImage = styled.svg`
    position: absolute;
    left: 0;
    top: 0;
`;

export default ReviewStar;
